import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { site } from "../data/site";
import { useT } from "../data/i18n";

export const Contact = () => {
  const { t } = useT();
  return (
    <>
      <Seo title="Contacto y horarios | Yasmina, restaurante árabe en Puigcerdà" description="Plaça del Reg, 1, Puigcerdà. Restaurante de cocina árabe y marroquí. Abierto cada día." path="/contacto" />
      <section className="menu-hero">
        <div className="container">
          <Reveal><div className="label">{t("contact_kicker")}</div></Reveal>
          <Reveal delay={1}><h1>{t("contact_title")}</h1></Reveal>
          <Reveal delay={2}>
            <p>{site.address}</p>
          </Reveal>
        </div>
      </section>

      <section style={{ paddingTop: 0 }}>
        <div className="container">
          <div className="contact-row" style={{ marginTop: 0 }}>
            <Reveal>
              <div className="map-wrap">
                <iframe
                  title="Ubicación Yasmina Puigcerdà"
                  src={site.mapEmbed}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  allowFullScreen
                  data-testid="contact-map-iframe"
                />
              </div>
            </Reveal>
            <Reveal delay={1}>
              <div className="hours-panel">
                <h3>{t("hours_title")}</h3>
                {site.hours.map((h) => (
                  <div key={h.day} className="hours-row">
                    <span>{h.day}</span><span>{h.time}</span>
                  </div>
                ))}
                <div style={{ opacity: 0.9, color: "var(--text)" }}>{site.address}</div>
                <div className="buttons">
                  <a href={site.mapLink} target="_blank" rel="noreferrer" className="btn ghost" data-testid="contact-page-map">{t("btn_maps_open")}</a>
                </div>
                <p style={{ fontSize: 13 }}>{t("contact_note")}</p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
};
